import { onUnmounted } from 'vue';
import { useRoute } from 'vue-router/composables';
import { useUserStore } from '@/stores/modules/user';
import yxhJsBridge from '@/shared/yxhJsBridge';
import { usePageTime } from './usePageTime';

export function useBackButton() {
  const route = useRoute();
  const userStore = useUserStore();
  const { enterTime } = usePageTime();

  const handleBackPressed = async () => {
    const currentPath = route.path;
    const currentQuery = route.query;

    if (
      currentPath.includes('/information') ||
      currentPath.includes('/contacts') ||
      currentPath.includes('/idMessage') ||
      (currentPath.includes('/face') && currentQuery.isCredit === '0')
    ) {
      window.dispatchEvent(new CustomEvent('showRetainPopup'));
      return;
    }

    const pageEndStr = JSON.stringify({
      eventIntervalSpan: Date.now() - enterTime.value,
      timeZone: new Date().getTime(),
      actionKey: 'page_end',
      pageTitle: route.meta?.trackingPgName,
      taskHandler: route.meta?.trackingPgName + '-pageout',
      ...userStore.commonData,
    });
    console.log(JSON.parse(pageEndStr), 'page end obj');
    yxhJsBridge.reportWebData(pageEndStr);
    yxhJsBridge.closeHostWeb();
  };

  const setBackButtonState = () => {
    yxhJsBridge.webOccupationBack('1');
    window.localBackPressed = handleBackPressed;
  };

  const setupBackPressed = () => {
    setBackButtonState();

    window.setupBackPressedAfterPopupClose = setBackButtonState;
  };

  onUnmounted(() => {
    yxhJsBridge.webOccupationBack('0');
    window.localBackPressed = () => {};
  });

  return {
    enterTime,
    setupBackPressed,
  };
}
